export default function guest({ next, store, router }) {
  if (store.state.user.authenticated) {
    return router.push({ name: 'index' });
  }

  return next();
}
